<template>
  <div class="min-h-screen bg-gray-900 text-white flex flex-col items-center justify-center p-4">
    <div class="text-center">
      <h1 class="text-9xl font-bold text-cyan-400">404</h1>
      <h2 class="text-3xl font-semibold mt-4 mb-2">{{ $t('notFound.title') }}</h2>
      <p class="text-gray-400 mb-8">{{ $t('notFound.message') }}</p>
      <router-link 
        to="/app/dashboard" 
        class="bg-cyan-600 hover:bg-cyan-700 text-white font-bold py-3 px-6 rounded-lg transition duration-300"
      >
        {{ $t('notFound.backButton') }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>